import type { Router } from 'vue-router';

/**
 * 创建进度条守卫，NProgress 是一个轻量级的进度条库，用于在页面加载时显示进度条 https://ricostacruz.com/nprogress/
 *
 * @param router - 路由实例
 */
export function createProgressGuard(router: Router) {
  router.beforeEach((_to, _from, next) => {
    window.NProgress?.start?.();
    next();
  });
  router.afterEach(_to => {
    window.NProgress?.done?.();
  });
}
